<template>
  <div class="inform-list px-3 pt-3 pb-2">
    <div class="inform-item" v-for="(inform, index) in items" :key="index">
      <h3 class="title">{{ index + 1 }}. {{ inform.request_item_name }}</h3>
      <div class="description mb-3">
        {{ inform.request_item_note || "-" }}
      </div>
      <div class="images">
        <sc-thumbnail
          v-for="(image, index) in inform.request_item_images"
          :key="index"
          :imgSrc="image.image_url"
          imgClass="sc-image p-0 mr-2 mb-2"
          :openLink="true"
        ></sc-thumbnail>
      </div>
    </div>
  </div>
</template>

<script>
import Thumbnail from "@/components/helper/Thumbnail";

export default {
  props: {
    items: {}
  },
  components: {
    "sc-thumbnail": Thumbnail
  },
  data() {
    return {
      informs: [
        {
          title: "ผนังห้องนอนมีรอยร้าว",
          description:
            "ประตูกันชนหลุดออกมา เอาชิ้นส่วนใหม่มาเปลี่ยนให้ด้วยเลยนะครับ",
          images: [
            "/static/sample/homecare/3.jpg",
            "/static/sample/homecare/4.jpg",
            "/static/sample/homecare/2.png"
          ]
        },
        { title: "ประตูกันชนหลุด", description: "", images: [] },
        { title: "วงกบประตูบวม", description: "", images: [] },
        {
          title: "ฉากกั้นห้องอาบน้ำเป็นรอยเเตกยาว  ",
          description:
            "ฉากกั้นห้องน้าเป็นรอยยาวมาก ร้าวไปถึงท่อประปาเลยครับ ช่วยมาดูหน่อยนะครับ",
          images: []
        },
        { title: "ผนังลอก", description: "", images: [] },
        { title: "กระเเบื้องแตก", description: "", images: [] }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.inform-item {
  padding: 16px;
  background: #f9f9f9;
  border-radius: 15px;
  margin-bottom: 8px;
}
h3.title {
  font-size: 16px;
  font-weight: bold;
  margin: 0 0 6px 0;
}
.description {
  font-size: 16px;
  font-weight: 500;
  color: #4a4a4a;
}
.images {
  display: flex;
  flex-wrap: wrap;
  .sc-image {
    border-radius: 13.6px;
    position: relative;
    width: 100px;
    height: 100px;
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view/homecare/InformList.vue